export const styles = (theme) => {
  const c = theme.palette.custom;
  return {
    card: {
      border: `1px solid ${c.borderColor}`,
      borderRadius: '12px',
      padding: '16px 20px',
      marginBottom: '20px',
      backgroundColor: c.white,
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: 'wrap',
    },
    headerTitle: { display: 'flex', alignItems: 'flex-start', gap: '10px', flex: '1 1 320px' },
    headerIcon: { color: theme.palette.primary.main, marginTop: '2px' },
    headerActions: { display: 'flex', alignItems: 'center', gap: '6px' },
    title: { fontSize: '18px', fontWeight: 600, color: c.textDark },
    subtitle: { fontSize: '13px', color: c.gray6 },
    usage: { fontSize: '12px', color: c.gray5, marginRight: '4px' },
    hint: { marginTop: '12px', fontSize: '14px', color: c.gray6 },
    suggestions: { display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '14px' },
    chip: {
      height: 'auto',
      padding: '6px 2px',
      backgroundColor: c.backgroundColor,
      border: `1px solid ${c.gray}`,
      '& .MuiChip-label': { whiteSpace: 'normal', fontSize: '13px' },
      '&:hover': { backgroundColor: theme.palette.primary.light },
    },
    thread: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '14px',
      maxHeight: '420px',
      overflowY: 'auto',
      paddingRight: '4px',
    },
    userBubble: {
      alignSelf: 'flex-end',
      maxWidth: '80%',
      backgroundColor: theme.palette.primary.main,
      color: c.white,
      borderRadius: '12px 12px 2px 12px',
      padding: '8px 12px',
    },
    answerBubble: {
      alignSelf: 'flex-start',
      maxWidth: '85%',
      backgroundColor: c.gray1,
      color: c.textDark,
      borderRadius: '12px 12px 12px 2px',
      padding: '10px 14px',
    },
    errorBubble: {
      alignSelf: 'flex-start',
      maxWidth: '85%',
      backgroundColor: c.lightPink,
      color: theme.palette.error.main,
      borderRadius: '12px 12px 12px 2px',
      padding: '10px 14px',
    },
    bubbleText: { fontSize: '14px', whiteSpace: 'pre-wrap', lineHeight: 1.5 },
    links: { display: 'flex', flexWrap: 'wrap', gap: '6px 14px', marginTop: '8px' },
    link: { fontSize: '13px', fontWeight: 600, textAlign: 'left' },
    thinking: { display: 'flex', alignItems: 'center', gap: '8px', color: c.gray6 },
    thinkingText: { fontSize: '13px' },
    inputRow: { display: 'flex', gap: '8px', alignItems: 'flex-end', marginTop: '14px' },
    sendButton: { minWidth: '90px', height: '40px', textTransform: 'none', boxShadow: 'none' },
    footnote: { fontSize: '11px', color: c.gray5, marginTop: '8px' },
  };
};
